const checkDevice = (size) => {
    let isMobile = false;
    if (size < 1000) {
        isMobile = true;
    } else {
        isMobile = false;
    }
    return isMobile;
}
export default checkDevice;